import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/base/PageMeta';
import Breadcrumb from '@/components/base/Breadcrumb';
import ContactForm from '@/components/feature/ContactForm';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: '首頁', item: 'https://lelyric.sonbook.net/' },
    { '@type': 'ListItem', position: 2, name: '聯絡我們', item: 'https://lelyric.sonbook.net/contact' },
  ],
};

export default function Contact() {
  return (
    <div className="min-h-screen bg-background-50">
      <PageMeta
        title="聯絡樂律｜書籍與品牌合作洽詢"
        description="如有樂律書籍、購書、版權、媒體或品牌經銷合作相關問題，請透過聯絡表單提出詢問。"
        canonicalPath="/contact"
        structuredData={breadcrumbSchema}
      />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative min-h-[300px] md:min-h-[420px] flex items-center bg-foreground-950 overflow-hidden">
          {/* Full-bleed background image */}
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20gentle%20flowing%20paper-like%20curves%20and%20subtle%20geometric%20forms%20suggesting%20connection%20and%20correspondence%2C%20warm%20ivory%20cream%20tones%20blending%20softly%20into%20deep%20muted%20charcoal%20and%20indigo%20shadows%2C%20soft%20diffused%20ambient%20light%20creating%20a%20calm%20professional%20atmosphere%2C%20editorial%20minimalism%20with%20fine%20grain%20texture%20and%20delicate%20surface%20details%2C%20serene%20contemplative%20mood%20suitable%20for%20a%20contact%20page%2C%20no%20people%2C%20no%20text%2C%20painterly%20modern%20digital%20art%20with%20understated%20elegance%2C%20publishing%20house%20brand%20visual%20identity%2C%20dark%20navy%20and%20warm%20neutral%20palette%2C%20generous%20breathing%20negative%20space&width=1600&height=800&seq=lelyric-contact-hero-bg&orientation=landscape"
              alt=""
              width={1600}
              height={800}
              className="w-full h-full object-cover"
            />
          </div>

          {/* Dark overlay for text readability */}
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/60 to-foreground-950/80"></div>

          {/* Fine horizontal rules */}
          <div className="absolute top-0 left-0 right-0 h-px bg-background-50/6"></div>
          <div className="absolute bottom-0 left-0 right-0 h-px bg-background-50/6"></div>

          {/* Page number */}
          <div className="absolute top-6 right-6 md:top-10 md:right-14 select-none pointer-events-none">
            <span className="font-heading text-5xl md:text-7xl font-bold text-background-50/[0.03]">04</span>
          </div>

          {/* Content */}
          <div className="relative z-10 w-full px-6 md:px-10 py-16 md:py-20">
            <div className="max-w-4xl mx-auto">
              <Breadcrumb
                items={[{ label: '首頁', href: '/' }, { label: '聯絡我們' }]}
                light
              />
              <div className="flex items-center gap-2.5 mb-6">
                <span className="block w-5 h-px bg-primary-400/40"></span>
                <span className="text-[13px] text-primary-400/70 tracking-[0.15em] uppercase font-medium">Contact</span>
              </div>
              <h1 className="font-heading text-[3rem] md:text-[4rem] font-bold text-background-50 leading-[1.12] tracking-tight mb-4">
                聯絡我們
              </h1>
              <p className="text-base md:text-lg text-background-50/50 max-w-xl leading-relaxed font-light tracking-wide">
                如有書籍、購書、版權、媒體或品牌經銷合作相關問題，請填寫以下表單。合作方案詳情請直接聯繫洽詢。
              </p>
            </div>
          </div>

          {/* Bottom gradient transition */}
          <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-background-50/20 to-transparent"></div>
        </section>

        {/* Form */}
        <section className="px-6 md:px-10 py-20 md:py-28 bg-background-50">
          <div className="max-w-2xl mx-auto">
            {/* Label */}
            <div className="flex items-center gap-2.5 mb-6">
              <span className="block w-5 h-px bg-primary-400/50"></span>
              <span className="text-[13px] font-medium text-primary-600 tracking-[0.15em] uppercase whitespace-nowrap">聯絡表單</span>
            </div>
            <h2 className="font-heading text-[2.25rem] md:text-[2.75rem] font-semibold text-foreground-950 mb-10 leading-[1.15] tracking-tight">
              提出詢問
            </h2>
            <ContactForm />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}